import React, {useContext, useEffect, useMemo, useState} from 'react';
import { OverlayTrigger, Tooltip, Tab, Nav, Col, Row} from 'react-bootstrap';
import WhatsappComponent from "./WhatsappComponent";
import SmsComponent from "./SmsComponent";
import EmailComponent from "./EmailComponent";
import VoipComponent from "./VoipComponent";
import "./style.scss";
import { WebSocketContext } from "../../../contexts/WebSocketContext";
import { AtendimentoContext } from "../../../contexts/AtendimentoContext";
import caAPI from "../../../services/caAPI";
import Swal from "sweetalert2";
import moment from 'moment';
import { celularMask } from "../../../components/InputTextMask";
import ChatBotComponent from './ChatBotComponent';
import ReclameAquiComponent from './ReclameAquiComponent';
import FacebookMessengerComponent from './FacebookMessengerComponent';
import InstagramComponent from './InstagramComponent';
import MidiaSocialIcone from '../../../components/MidiaSocialIcone';
import {BrowserView, MobileView} from 'react-device-detect';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight,faCommentAlt,faGraduationCap,faInfoCircle,faPhoneAlt, faRobot, faSpinner} from "@fortawesome/free-solid-svg-icons";
import DommusBarraTitulo from "../../../components/DommusBarraTitulo";
import ItemBarraTitulo from "../../../components/DommusBarraTitulo/ItemBarraTitulo";
import DommusScrollAnchor from "../../../components/DommusScrollAnchor";
import PresencialComponent from './PresencialComponent';
import {trackPromise, usePromiseTracker} from "react-promise-tracker";
import DommusLoading from '../../../components/DommusLoading/DommusLoading';
import { errorToast, successToast } from '../../../components/DommusToast';
import { PerfilUsuarioService } from '../../../services/PerfilUsuarioService';

export default function DetalheAtendimento({callbackVoltar, children}) {
    const { 
      atendimentoAtivo, 
      setAtendimentoAtivo, 
      isOpenInformacoesAtendimento, 
      setIsOpenInformacoesAtendimento, 
      promiseBuscaAtendimentoEmProgresso
    } = useContext(AtendimentoContext);
    const ws = useContext(WebSocketContext);
    const [showVoipIcon, setVoipIcon] = useState(false);
    const [enableAIAssistant, setEnableAIAssistant] = useState(false);
    const [podeAtivarDesativarIa, setPodeAtivarDesativarIa] = useState(false);
    const [podeCurarAprendizado, setPodeCurarAprendizado] = useState(false);
    const [modoSelecaoAprendizado, setModoSelecaoAprendizado] = useState(false);
    const promiseAssistenteIaAtendimento = 'promise-assistente-ia';
    const { promiseInProgress } = usePromiseTracker({ area: promiseAssistenteIaAtendimento });

    useEffect(() => {
        setEnableAIAssistant(atendimentoAtivo?.atendimento_por_ia_ativado || false);
        ws.channel.bind('atendimento.' + atendimentoAtivo.id, res => {
            if (atendimentoAtivo.id === res.id_atendimento) {
                atualizaAtendimento(atendimentoAtivo.id);
            }
        });
        
        if(atendimentoAtivo?.meio?.nome === "Whatsapp" || atendimentoAtivo?.meio_comunicacao?.nome === 'Whatsapp') {
          caAPI.configuracoes.buscar("voip_automatico").then(res => {
            if(res.data.valor) {
              setVoipIcon(res.data.valor);
            }
          }).catch(error => console.log(error))
        }

        return () => {
            ws.channel.unbind('atendimento.' + atendimentoAtivo.id);
        }
    }, [atendimentoAtivo]);

    useEffect(() => {
        PerfilUsuarioService.buscarDadosPerfil().then(res => {
            setPodeAtivarDesativarIa(res.data?.data?.perfil?.permitir_ativar_desativar_ia ?? false);
            setPodeCurarAprendizado(res.data?.data?.perfil?.permitir_curadoria_aprendizado ?? false);
        }).catch(() => {
            setPodeAtivarDesativarIa(false);
            setPodeCurarAprendizado(false);
        });
    }, []);

    // Trocar de atendimento encerra o modo de seleção de curadoria.
    useEffect(() => {
        setModoSelecaoAprendizado(false);
    }, [atendimentoAtivo?.id]);

    function atualizaAtendimento(id_atendimento) {
        caAPI.atendimento.find(id_atendimento).then(res => {
            setAtendimentoAtivo(res.data)
        }).catch(error => {
            if(error?.response?.status == 404) {
                Swal.fire({
                    titleText: "Erro",
                    text: "Você não possui permissão para visualizar este atendimento.",
                    icon: 'error'
                });
                setAtendimentoAtivo(null)

                return
            }
            Swal.fire({
                titleText: "Erro",
                text: "Houve um problema ao atualizar as mensagens",
                icon: 'error'
            });
            return;
        })
    }
    
    async function abrirVoip(atendimento) {
      const idReferencia = atendimento?.origem?.id_contato_referencia;
      if (!idReferencia) {
        Swal.fire({
          titleText: "Atenção",
          text: "Nenhuma referencia vinculada a este contato!",
          icon: 'info'
        });
        return
      }
      const contato_origem = await caAPI.contato_origem.buscarContatoOrigem(idReferencia);
      const data = {
        contato_origem: contato_origem.data.valor,
        contato_destino: atendimento.contato_origem,
        meio_comunicacao: "voip",
        nome: atendimento.nome,
        situacao: atendimento.situacao,
        tags: atendimento.tags,
        tipo_atendimento: atendimento.tipo_atendimento.id,
      };
      Swal.fire({
        titleText: "Abrir um Voip",
        text: "Tem certeza que quer abrir um Voip ?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: "Sim",
        cancelButtonText: `Cancelar`
      }).then((result) => {
        if (result.isConfirmed) {
          trackPromise(caAPI.atendimento.create(data).then(res => {
            if(res.data) {
              window.open("/atendimento?idAtendimento=" + res.data.id, "_blank");
            }
          }).catch(err => {
            Swal.fire({
              titleText: "Erro",
              text: "Erro ao criar/editar atendimento",
              icon: 'error'
            });
          }))
        }
      });
    }

    const contatoDestinoComMascara = useMemo(()=>{
        switch(atendimentoAtivo.meio_comunicacao.slug){
            case "whatsapp": case "voip": case "sms":
                return celularMask(atendimentoAtivo.contato_destino)
            default:
                return (atendimentoAtivo.contato_destino)
        }
    }, [atendimentoAtivo]);

    const AtendimentoComponent = useMemo(() => {
        if (atendimentoAtivo) {
          if(promiseBuscaAtendimentoEmProgresso) {
            return <DommusLoading loadWrapperPosition="relative" fundo="transparent"/>
          }
            switch (atendimentoAtivo.meio_comunicacao.slug) {
                case "whatsapp":
                    return <WhatsappComponent
                        modoSelecao={modoSelecaoAprendizado}
                        onSairModoSelecao={() => setModoSelecaoAprendizado(false)}
                    />
                case "sms":
                    return <SmsComponent atendimento={atendimentoAtivo} />
                case "email":
                    return <EmailComponent atendimento={atendimentoAtivo} AtualizarListaEmails={atualizaAtendimento} />
                case "voip":
                    return <VoipComponent />
                case "chatbot":
                    return <ChatBotComponent atendimento={atendimentoAtivo} />
                case "reclame-aqui":
                    return <ReclameAquiComponent atendimento={atendimentoAtivo}/>
                case "facebook-messenger":
                    return <FacebookMessengerComponent atendimento={atendimentoAtivo}/>
                case "instagram":
                    return <InstagramComponent atendimento={atendimentoAtivo}/>
                case "presencial":
                    return <PresencialComponent/>
                default:
                    return <div>{atendimentoAtivo.meio_comunicacao.nome} não é suportado</div>
            }
        }
    }, [promiseBuscaAtendimentoEmProgresso, atendimentoAtivo, modoSelecaoAprendizado])

    const botaoCriarExemploAprendizado = useMemo(() => {
      return atendimentoAtivo.meio_comunicacao.slug === 'whatsapp' && podeCurarAprendizado && <OverlayTrigger
        key="icon-curadoria-aprendizado"
        placement="left"
        overlay={
          <Tooltip id={`tooltip-curadoria-aprendizado`}>
            {modoSelecaoAprendizado ? 'Sair da seleção de mensagens' : 'Criar exemplo de aprendizado'}
          </Tooltip>
        }
      >
        <div
          className={`btn-curadoria-aprendizado ${modoSelecaoAprendizado ? 'active' : ''}`}
          id="btn-criar-exemplo-aprendizado"
          onClick={() => setModoSelecaoAprendizado(current => !current)}
        >
          <FontAwesomeIcon icon={faGraduationCap} />
        </div>
      </OverlayTrigger>
    }, [atendimentoAtivo, podeCurarAprendizado, modoSelecaoAprendizado])

    const botaoAtivarDesativarAssistenteIa = useMemo(() => {
      const ativarDesativarAssistenteIaAtendimento = () => {
        const novoEstadoIa = !enableAIAssistant;
        trackPromise(caAPI.atendimento.update({ atendimento_por_ia_ativado: novoEstadoIa }, atendimentoAtivo.id), promiseAssistenteIaAtendimento)
          .then(() => {
            successToast.fire({ text: `Assistente de IA ${novoEstadoIa ? 'ativado' : 'desativado'} com sucesso!` });
            // Atualiza a fonte de verdade do atendimento para o WhatsappComponent
            // recomputar o bloqueio do input sem precisar reabrir o atendimento.
            setAtendimentoAtivo(atendimento => atendimento && { ...atendimento, atendimento_por_ia_ativado: novoEstadoIa });
          })
          .catch(() => errorToast.fire({ text: `Erro ao ${novoEstadoIa ? 'ativar' : 'desativar'} assistente de IA!` }));
        setEnableAIAssistant(novoEstadoIa);
      }
      return atendimentoAtivo.meio_comunicacao.slug === 'whatsapp' && atendimentoAtivo.agente_ia_configurado && podeAtivarDesativarIa && <OverlayTrigger
        key="icon-ai-assistant"
        placement="left"
        overlay={
          <Tooltip id={`tooltip-ai-assistant`}>
            {enableAIAssistant ? 'Desabilitar Assistente de IA' : 'Habilitar Assistente de IA'}
          </Tooltip>
        }
      >
        <div
          className={`btn-ai-assistant ${enableAIAssistant ? 'active' : 'inactive'} ${promiseInProgress ? 'loading' : ''}`}
          onClick={ativarDesativarAssistenteIaAtendimento}
          style={{pointerEvents: promiseInProgress ? 'none' : 'auto'}}
        >
          <FontAwesomeIcon icon={promiseInProgress ? faSpinner : faRobot} />
        </div>
      </OverlayTrigger>
    }, [enableAIAssistant, atendimentoAtivo, promiseInProgress, podeAtivarDesativarIa])

    const title = () => {
        return (
          <div className="contatoToggle">
            <div className="contatoInfo">
              <div className='icon-meio_comunicao'>
                  <MidiaSocialIcone midia={atendimentoAtivo.meio_comunicacao?.slug|| null} />
              </div>
              <OverlayTrigger
                  key="IconMeioComunicacao"
                  placement="top"
                  overlay={
                      <Tooltip id={`tooltip-editar`}>
                          {contatoDestinoComMascara}
                      </Tooltip>
                  }
                  >
                  <div className='nome-contato' style={{maxWidth: isOpenInformacoesAtendimento ? "13rem" : "20rem" }}>
                      {atendimentoAtivo.nome ? atendimentoAtivo.nome : contatoDestinoComMascara}
                  </div>
              </OverlayTrigger>
              <div className="dataContato"> {'\u2B95'} </div>
              <OverlayTrigger
                  key="IconDataContato"
                  placement="top"
                  overlay={
                      <Tooltip id={`tooltip-editar`}>
                          Última atualização
                      </Tooltip>
                  }
                  >
                  <div className='data-hora-contato'>
                      <div className="dataContato">
                          {moment(atendimentoAtivo.dtatendimento).format('DD/MM/YYYY')}
                      </div>
                      <div className="dataContato"> às </div>
                      <div className="dataContato">
                          {moment(atendimentoAtivo.dtatendimento).format('HH:mm')}
                      </div>
                  </div>
              </OverlayTrigger>
            </div>
            <div className="container-botoes">
              {(showVoipIcon && atendimentoAtivo.meio_comunicacao.slug === "whatsapp") && (
                <OverlayTrigger
                  key="icon-open-voip"
                  placement="left"
                  overlay={
                    <Tooltip id={`tooltip-open-voip`}>
                      Abrir um Voip
                    </Tooltip>
                  }
                >
                  <div
                    className='btn-abrir-voip'
                    onClick={()=>{abrirVoip(atendimentoAtivo)}}
                  >
                    <FontAwesomeIcon icon={faPhoneAlt}/>
                  </div>
                </OverlayTrigger>
              )}

              {botaoCriarExemploAprendizado}

              {botaoAtivarDesativarAssistenteIa}

              <OverlayTrigger
                key="icon-open-informacoes"
                placement="left"
                overlay={
                    <Tooltip id={`tooltip-open-informacoes`}>
                       Abrir informações do atendimento 
                    </Tooltip>
                }
              >
                <div
                  className='btn-abrir-informacoes'
                  onClick={()=>{setIsOpenInformacoesAtendimento((current) => !current)}}
                >
                  <FontAwesomeIcon icon={isOpenInformacoesAtendimento ? faArrowRight : faInfoCircle}/>
                </div>
              </OverlayTrigger>
            </div>
          </div>
        )
    }

    const mobileTitle = () => {
        return (
          <div className="contatoToggle">
            <div 
              className='btn-voltar-atendimentos'
              onClick={callbackVoltar}  
            >
              <FontAwesomeIcon icon={faArrowLeft}/>
            </div>

              <div className="contatoInfo">
                <div className='icon-meio_comunicao'>
                    <MidiaSocialIcone
                     midia={atendimentoAtivo.meio_comunicacao?.slug|| null}
                     contatoOrigem={atendimentoAtivo.origem?.descricao}
                    />
                </div>
                <div className='data-user-mobile'>
                  <div className='nome-contato'>
                      {atendimentoAtivo.nome ? atendimentoAtivo.nome : contatoDestinoComMascara}
                  </div>
                  <div className='data-hora-contato'>
                      <div className="dataContato">
                          {moment(atendimentoAtivo.dtatendimento).format('DD/MM/YYYY')}
                      </div>
                      <div className="dataContato"> às </div>
                      <div className="dataContato">
                          {moment(atendimentoAtivo.dtatendimento).format('HH:mm')}
                      </div>
                  </div>
                </div>
                {botaoCriarExemploAprendizado}
                {botaoAtivarDesativarAssistenteIa}
                <div 
                  className='btn-abrir-informacoes'
                  onClick={()=>{setIsOpenInformacoesAtendimento((current) => !current)}}  
                >
                  <FontAwesomeIcon icon={isOpenInformacoesAtendimento ? faCommentAlt : faInfoCircle}/>
                </div>
              </div>
          </div>
        )
    }

    return (<>
            <BrowserView>
              <div className='detalhes-atendimento-title-section' style={{borderTopRightRadius: isOpenInformacoesAtendimento ? "0px" : "10px"}}>
                {title()}
              </div>
              <div className='dommus-toggle-height-fixed center-container-toggle height-coluna-atendimento'>
                {AtendimentoComponent}
              </div>
            </BrowserView>
            <MobileView>
              <div className="mobile-view-barra-titulo">
                <DommusBarraTitulo>
                  <ItemBarraTitulo>
                  {mobileTitle()}
                  </ItemBarraTitulo>
                </DommusBarraTitulo>
              </div>
                <Row>
                  <Col sm={12}>
                    <div className="mobileTab">
                      {!isOpenInformacoesAtendimento ?
                        <>
                          {AtendimentoComponent}
                          <DommusScrollAnchor></DommusScrollAnchor>
                        </>
                      : children
                      }
                    </div>
                  </Col>
                </Row>
            </MobileView>
            </>
    );
}
